/*
 * Copyright (C) 2025 Netgem SA
 *
 * This software is the copyrighted work of Netgem and constitutes
 * confidential information.
 *
 * By using this software you agree to hold the Confidential Information in
 * strict confidence and shall not disclose such information to any third party
 * without the written permission of Netgem SA. You also agree to employ all
 * steps necessary to protect the Confidential Information from unauthorized
 * disclosure or use, including without limitation, all steps you use to protect
 * information considered proprietary and a trade secret.
 */

import { ENV } from '@services/environment';

const STORAGE_KEY = 'neo_app_endpoint_type';

export const getStoredEnvironment = (): EndpointTypes => {
    const stored = localStorage.getItem(STORAGE_KEY) as EndpointTypes;
    return Object.values(EndpointTypes).includes(stored)
        ? stored
        : EndpointTypes.PROD;
};

export enum EndpointTypes {
    LABS = 'labs',
    PROD = 'prod',
}

type Endpoints = {
    [key in EndpointTypes]: string | undefined;
};

const endpoints: Endpoints = {
    labs: import.meta.env.VITE_LIMECRAFT_LABS_BASEURL,
    prod: import.meta.env.VITE_LIMECRAFT_PROD_BASEURL,
};

export const setEnvironment = (env: EndpointTypes) => {
    localStorage.setItem(STORAGE_KEY, env);
    window.location.reload();
};

export const getBaseUrl = () => {
    const currentEnv = getStoredEnvironment();
    const res = ENV.isDevelopment() ? `/${currentEnv}` : endpoints[currentEnv];
    return res;
};

export const getVivaBaseUrl = () => {
    return import.meta.env.VITE_NETGEM_PROXY_BASEURL;
};

type AccountWhitelists = {
    [key in EndpointTypes]: string[];
};

const ACCOUNT_WHITELIST: AccountWhitelists = {
    [EndpointTypes.LABS]: [
        '118', // Eclair Preservation
    ],
    [EndpointTypes.PROD]: [
        '4005', // Eclair Preservation
    ],
};

export const getAccountsWhitelist = () =>
    ACCOUNT_WHITELIST[getStoredEnvironment()];

export const getCurrentEndpointType = () => getStoredEnvironment();
